<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span style="font-size: 24px">{{
        JSON.parse(this.$UrlEncode.decode(this.$route.query.key)).name
      }}</span>
      <div class="head-text" style="float: right">
        <el-input
          placeholder="请输入"
          class="search-input"
          style="width: 300px"
          v-model="searchword"
        ></el-input>
        <el-button
          slot="append"
          icon="el-icon-search"
          class="mar-t80"
        ></el-button>
        <el-button @click="showAddForm(null)" type="primary" plain
          >新增</el-button
        >
      </div>
    </div>
    <el-container>
      <!-- 这里是侧边栏*-->
      <div class="mar-top20">
        <el-aside width="200px" class="elAside">
          <zTree
            style="height: 365px"
            :treeData="zNodes"
            :isAllchecked="true"
            :item="item"
            @updateIds="updateIds"
            ref="zTree"
          />
        </el-aside>
      </div>
      <el-main>
        <div class="rygl-table">
          <el-table
            height="72vh"
            align="center"
            class="table"
            :data="functionList"
          >
            <el-table-column
              align="center"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="fmtp03"
              label="模版名称"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="tempName"
              label="所属模块"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="name"
              label="创建人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="fmtp06"
              label="创建时间"
            ></el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="showAddForm(scope.row)"
                  size="small"
                  type="primary"
                  plain
                  >编辑</el-button
                >
                <el-popconfirm
                  @confirm="DelOneFormTemp(scope.row.fmtp01)"
                  title="确定删除吗？"
                  style="margin-left: 10px"
                >
                  <el-button
                    slot="reference"
                    v-if="scope.row.fmtp02"
                    size="small"
                    type="danger"
                    plain
                    >删除</el-button
                  >
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-main>
      <!-- 新增功能模块弹窗 -->
      <ability ref="ability" @signStatusVerdict="listDataStatus"></ability>
    </el-container>
  </el-card>
</template>
<script>
import zTree from "@/components/compontZtree";
import ability from "@/components/ability";
import {
  GetFunctionTemplate,
  AddOrUpdateFunctionTemplate,
  DropFunctionTemplate,
  DelFunctionTemplate,
  GetFormTempLists,
  DelOneFormTemps,
} from "@/setAxios.js";
export default {
  name: "",
  props: {},
  components: { zTree, ability },
  data() {
    return {
      item: { name: "fctm02", parentName: "fctm03", id: "fctm01" },
      zNodes: [],
      searchword: "",
      functionList: [],
      key: {},
      tatol: 0,
      ids: "",
    };
  },
  computed: {},
  watch: {
    $route: {
      handler: function(val, oldVal) {
        this.getInitZtree();
        this.key = JSON.parse(this.$UrlEncode.decode(this.$route.query.key));
        localStorage.setItem("keyId", this.key.type);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    getInitZtree() {
      let _this = this;
      // 超管端
      let params = {
        companyId: localStorage.pid,
        xid: localStorage.xid,
      };

      GetFunctionTemplate({ params }).then((res) => {
        if (res.Code) {
          _this.zNodes = _this
            .getTreeDate(res.Data.projectfunctiontemplates, "fctm01", "fctm03")
            .filter((el) => el.fctm01 == _this.key.type);
          // 模板配置中的keyId
        }
      });
    },
    getTreeDate(data, idName, pidName) {
      let result = [];
      if (!Array.isArray(data)) {
        return result;
      }
      data.forEach((item) => {
        delete item.children;
      });
      let map = {};
      data.forEach((item) => {
        map[item[idName]] = item;
      });

      data.forEach((item) => {
        let parent = map[item[pidName]];
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          result.push(item);
        }
      });
      return result;
    },
    updateIds(date) {
      this.ids = date.join();
      this.GetFormTempLists();
    },
    GetFormTempLists() {
      GetFormTempLists({
        params: {
          xid: localStorage.xid,
          searchword: "",
          pageIndex: 1,
          pageSize: 10000,
          functempIds: this.ids,
        },
      }).then((res) => {
        // 超管的模版为第一位
        this.functionList = res.Data.list.sort((a, b) => {
          return a.fmtp07 - b.fmtp07;
        });
      });
    },

    // 打开功能模板
    showAddForm(data) {
      if (data) {
        this.$refs.ability.Id = data.fmtp01;
        this.$refs.ability.Admin = data.fmtp07;
      }else{
        this.$refs.ability.Id = null;
        this.$refs.ability.Admin = null;
      }
      this.$refs.ability.open();
    },
    async DelOneFormTemp(id) {
      let params = {
        id,
      };
      let res = await DelOneFormTemps(params);
      if (res.Code > 0) {
        this.$message.success("删除成功!");
        this.GetFormTempLists();
      }
    },
    //子组件中刷新父
    listDataStatus() {
      this.GetFormTempLists();
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.mar-top20 {
  margin-top: 20px;
}
.elAside {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  text-align: center;
}
#PdeptTree {
  height: 500px;
}
.zTreeDiv {
  overflow: auto;
}
.ztree li span {
  // color: #fff;
  line-height: 21px;
  margin-right: 2px;
}
</style>
